namespace TabAurous.OMS {
    export namespace MarkupChargesService {
        export const baseUrl = 'OMS/MarkupCharges';

        export declare function Create(request: Serenity.SaveRequest<MarkupChargesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MarkupChargesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MarkupChargesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MarkupChargesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetMarkUp(request: MarkUpRequest, onSuccess?: (response: Common.MarkUpResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/MarkupCharges/Create",
            Update = "OMS/MarkupCharges/Update",
            Delete = "OMS/MarkupCharges/Delete",
            Retrieve = "OMS/MarkupCharges/Retrieve",
            List = "OMS/MarkupCharges/List",
            GetMarkUp = "OMS/MarkupCharges/GetMarkUp"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetMarkUp'
        ].forEach(x => {
            (<any>MarkupChargesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
